import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";

const Impressum = () => (
  <Layout>
    <SEOHead
      title="Impressum | heilys.info"
      description="Rechtliche Angaben und Anbieterkennzeichnung von heilys.info."
      canonical="https://heilys.info/impressum"
      noIndex={false}
      schemaJson={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Startseite", item: "https://heilys.info/" },
          { "@type": "ListItem", position: 2, name: "Impressum", item: "https://heilys.info/impressum" },
        ],
      }}
    />
    <div className="container py-16 md:py-24">
      <div className="mx-auto max-w-2xl">
        <h1 className="font-display text-3xl font-bold text-foreground">Impressum</h1>

        <div className="mt-8 space-y-6 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Angaben gemäß § 5 TMG</h2>
            <p className="mt-2">
              heilys.info wird als private, unabhängige Informationsseite betrieben. Die Seite dient der redaktionellen Orientierung rund um Produkte der Marke heilys und ist kein gewerblicher Online-Shop.
            </p>
            <p className="mt-2">
              Betreiber:<br />
              BENORA GROUP OOD<br />
              Company ID (EIK): 208501713<br />
              Hvoyna Str. 5<br />
              2700 Blagoevgrad<br />
              Bulgarien
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Kontakt</h2>
            <p className="mt-2">
              E-Mail: info@longevity-hackers.de<br />
              Bitte beachte, dass wir keine Bestellungen entgegennehmen und keinen Kundensupport für den heilys Shop leisten. Für Fragen zu Bestellungen, Lieferungen oder Retouren wende dich bitte direkt an den offiziellen heilys Kundenservice.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="mt-2">
              BENORA GROUP OOD<br />
              Hvoyna Str. 5, 2700 Blagoevgrad, Bulgarien
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Haftungsausschluss (Disclaimer)</h2>
            <h3 className="mt-3 text-sm font-medium text-foreground">Haftung für Inhalte</h3>
            <p className="mt-1">
              Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <h3 className="mt-3 text-sm font-medium text-foreground">Haftung für Links</h3>
            <p className="mt-1">
              Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            <h3 className="mt-3 text-sm font-medium text-foreground">Urheberrecht</h3>
            <p className="mt-1">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
          </section>

          <section>
            <h2 className="font-display text-base font-semibold text-foreground">Hinweis zur Unabhängigkeit</h2>
            <p className="mt-2">
              heilys.info ist eine unabhängige Informationsseite und steht in keiner direkten geschäftlichen Verbindung zur Firma heilys. Wir sind weder der offizielle heilys Shop noch ein autorisierter Händler. Bei Käufen über auf dieser Seite verlinkte Partnerlinks kann eine Provision anfallen, ohne dass dir dadurch Mehrkosten entstehen. Alle Produktinformationen basieren auf öffentlich zugänglichen Herstellerangaben und eigener Recherche.
            </p>
          </section>

          <p className="mt-8 text-sm text-muted-foreground">
            Zurück zur{" "}
            <Link to="/#ueber-heilys" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
              heilys Marken-Übersicht
            </Link>{" "}
            oder zur{" "}
            <Link to="/" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
              heilys Rabattcode Startseite
            </Link>.
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default Impressum;
